import {useLocalization} from '@shopify/hydrogen';
import {languages} from '../languages';

export default function getIsoCode() {
  const {country} = useLocalization();
  const isoCode = country.isoCode.toLowerCase();
  return languages.includes(isoCode) ? isoCode : 'en';
}
